import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  key: 3,
  class: "dottedbox mb-5"
}
const _hoisted_3 = { class: "px-10" }
const _hoisted_4 = {
  key: 0,
  class: "text-muted my-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (
      !$setup.notification1 &&
      !$setup.notification2 &&
      !$setup.notification3 &&
      ($setup.trigger?.toLowerCase() != 'Indisponibilidade / Conectividade do Link'?.toLowerCase() ||
        $setup.trigger?.toLowerCase() != 'Indisponibilidade'?.toLowerCase() ||
        $setup.trigger?.toLowerCase() != 'Conectividade do Link'?.toLowerCase())
    )
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 0,
          class: "ms-3"
        }, {
          default: _withCtx(() => [
            (!$setup.props.stepTri)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 0,
                  md: "6",
                  cols: "12"
                }, {
                  default: _withCtx(() => [
                    _createVNode($setup["AtomSelect"], {
                      modelValue: $setup.TypeNot,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.TypeNot) = $event)),
                      placeholder: "Clique aqui...",
                      hasError: $setup.listError.includes('Tipo da Notificação'),
                      label: "Tipo da Notificação:",
                      color: `#697B8E`,
                      options: $setup.TypeNotification,
                      class: "mb-3"
                    }, null, 8 /* PROPS */, ["modelValue", "hasError", "options"])
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_v_col, {
              cols: "12",
              md: $setup.props.stepTri ? 4 : 6
            }, {
              default: _withCtx(() => [
                (!$setup.props.stepTri)
                  ? (_openBlock(), _createBlock($setup["AtomSelect"], {
                      key: 0,
                      modelValue: $setup.trigger,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.trigger) = $event)),
                      placeholder: "Clique aqui...",
                      hasError: $setup.listError.includes('Condição do gatiho'),
                      label: "Condição do gatiho:",
                      color: `#697B8E`,
                      options: $setup.optionsSelect,
                      class: "mb-3"
                    }, null, 8 /* PROPS */, ["modelValue", "hasError", "options"]))
                  : _createCommentVNode("v-if", true),
                ($setup.props.stepTri)
                  ? (_openBlock(), _createBlock($setup["AtomSelect"], {
                      key: 1,
                      placeholder: "Clique aqui...",
                      hasError: $setup.listError.includes('Tempo da 1ª Notificação'),
                      label: "Tempo da 1ª Notificação:",
                      color: `#697B8E`,
                      options: $setup.optionsSelectTime,
                      modelValue: $setup.dados.timeFirstNotification,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.dados.timeFirstNotification) = $event)),
                      class: "mb-3"
                    }, null, 8 /* PROPS */, ["hasError", "options", "modelValue"]))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["md"]),
            ($setup.props.stepTri)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 1,
                  md: "4",
                  cols: "6"
                }, {
                  default: _withCtx(() => [
                    _createVNode($setup["AtomSelect"], {
                      placeholder: "Clique aqui...",
                      hasError: $setup.listError.includes('Operador Lógico'),
                      label: "Operador Lógico:",
                      color: `#697B8E`,
                      options: $setup.jitter,
                      modelValue: $setup.dados.operador1,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.dados.operador1) = $event)),
                      class: "mb-3"
                    }, null, 8 /* PROPS */, ["hasError", "options", "modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            ($setup.props.stepTri)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 2,
                  md: "4",
                  cols: "6"
                }, {
                  default: _withCtx(() => [
                    _createVNode($setup["AtomInput"], {
                      modelValue: $setup.dados.ValorRegra1,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.dados.ValorRegra1) = $event)),
                      label: "Valor:",
                      appendIcon: "",
                      color: `#697B8E`,
                      class: "mb-3",
                      width: "100%",
                      bgIcon: "#FFEFE6",
                      type: "number"
                    }, {
                      appendIcon: _withCtx(() => _cache[30] || (_cache[30] = [
                        _createElementVNode("p", { style: {"color":"#ff5c00"} }, "Valor", -1 /* HOISTED */)
                      ])),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_v_col, {
              cols: "12",
              md: $setup.props.stepTri ? 4 : 6
            }, {
              default: _withCtx(() => [
                _createCommentVNode(" <AtomSelect placeholder=\"Clique aqui...\" v-if=\"!props.stepTri\" :type=\"'text'\" :background-color=\"`#697B8E`\"\r\n        :hasError=\"listError.includes('Tipo de notificações')\" label=\"Tipo de notificações:\"\r\n        :options=\"optionsSelectNotification\" v-model=\"dados.typeNotifications\">\r\n      </AtomSelect> "),
                (!$setup.props.stepTri)
                  ? (_openBlock(), _createBlock($setup["AtomInput"], {
                      key: 0,
                      modelValue: $setup.dados.tituloNotificacao,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.dados.tituloNotificacao) = $event)),
                      label: "Titulo da notificação:",
                      color: `#697B8E`,
                      class: "mb-3",
                      width: "100%",
                      type: "text"
                    }, null, 8 /* PROPS */, ["modelValue"]))
                  : _createCommentVNode("v-if", true),
                ($setup.props.stepTri && $setup.TypeNot != 'CONTINUA')
                  ? (_openBlock(), _createBlock($setup["AtomSelect"], {
                      key: 1,
                      placeholder: "Clique aqui...",
                      type: 'text',
                      "background-color": `#697B8E`,
                      hasError: $setup.listError.includes('Tempo da 2ª Notificação'),
                      options: $setup.optionsSelectTime,
                      label: "Tempo da 2ª Notificação:",
                      modelValue: $setup.dados.timeSecondNotification,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.dados.timeSecondNotification) = $event))
                    }, null, 8 /* PROPS */, ["hasError", "options", "modelValue"]))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["md"]),
            ($setup.props.stepTri && $setup.TypeNot != 'CONTINUA')
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 3,
                  md: "4",
                  cols: "6"
                }, {
                  default: _withCtx(() => [
                    _createVNode($setup["AtomSelect"], {
                      placeholder: "Clique aqui...",
                      hasError: $setup.listError.includes('Jitter atual'),
                      label: "Operador Lógico:",
                      color: `#697B8E`,
                      options: $setup.jitter,
                      modelValue: $setup.dados.operador2,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.dados.operador2) = $event)),
                      class: "mb-3"
                    }, null, 8 /* PROPS */, ["hasError", "options", "modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            ($setup.props.stepTri && $setup.TypeNot != 'CONTINUA')
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 4,
                  md: "4",
                  cols: "6"
                }, {
                  default: _withCtx(() => [
                    _createVNode($setup["AtomInput"], {
                      modelValue: $setup.dados.ValorRegra2,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.dados.ValorRegra2) = $event)),
                      label: "Valor:",
                      appendIcon: "",
                      color: `#697B8E`,
                      class: "mb-3",
                      width: "100%",
                      bgIcon: "#FFEFE6",
                      type: "number"
                    }, {
                      appendIcon: _withCtx(() => _cache[31] || (_cache[31] = [
                        _createElementVNode("p", { style: {"color":"#ff5c00"} }, "Valor", -1 /* HOISTED */)
                      ])),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_v_col, {
              cols: "12",
              md: $setup.props.stepTri ? 4 : 6
            }, {
              default: _withCtx(() => [
                (!$setup.props.stepTri)
                  ? (_openBlock(), _createBlock($setup["AtomSelect"], {
                      key: 0,
                      modelValue: $setup.dados.company,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.dados.company) = $event)),
                      placeholder: "Clique aqui...",
                      hasError: $setup.listError.includes('empresas'),
                      label: "Empresa:",
                      options: $setup.companhias,
                      color: `#697B8E`,
                      class: "mb-3"
                    }, null, 8 /* PROPS */, ["modelValue", "hasError", "options"]))
                  : _createCommentVNode("v-if", true),
                ($setup.props.stepTri && $setup.TypeNot != 'CONTINUA')
                  ? (_openBlock(), _createBlock($setup["AtomSelect"], {
                      key: 1,
                      placeholder: "Clique aqui...",
                      hasError: $setup.listError.includes('Tempo da 3ª Notificação'),
                      label: "Tempo da 3ª Notificação:",
                      options: $setup.optionsSelectTime,
                      color: `#697B8E`,
                      modelValue: $setup.dados.timeThirdNotification,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.dados.timeThirdNotification) = $event)),
                      class: "mb-3"
                    }, null, 8 /* PROPS */, ["hasError", "options", "modelValue"]))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["md"]),
            ($setup.props.stepTri && $setup.TypeNot != 'CONTINUA')
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 5,
                  md: "4",
                  cols: "6"
                }, {
                  default: _withCtx(() => [
                    _createVNode($setup["AtomSelect"], {
                      placeholder: "Clique aqui...",
                      hasError: $setup.listError.includes('Jitter atual'),
                      label: "Operador Lógico:",
                      color: `#697B8E`,
                      options: $setup.jitter,
                      modelValue: $setup.dados.operador3,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.dados.operador3) = $event)),
                      class: "mb-3"
                    }, null, 8 /* PROPS */, ["hasError", "options", "modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            ($setup.props.stepTri && $setup.TypeNot != 'CONTINUA')
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 6,
                  md: "4",
                  cols: "6"
                }, {
                  default: _withCtx(() => [
                    _createVNode($setup["AtomInput"], {
                      modelValue: $setup.dados.ValorRegra3,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.dados.ValorRegra3) = $event)),
                      label: "Valor:",
                      appendIcon: "",
                      color: `#697B8E`,
                      class: "mb-3 w-50",
                      width: "100%",
                      bgIcon: "#FFEFE6",
                      type: "number"
                    }, {
                      appendIcon: _withCtx(() => _cache[32] || (_cache[32] = [
                        _createElementVNode("p", { style: {"color":"#ff5c00"} }, "Valor", -1 /* HOISTED */)
                      ])),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            (!$setup.props.stepTri)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 7,
                  md: "6",
                  cols: "12"
                }, {
                  default: _withCtx(() => [
                    _createVNode($setup["AtomSelect"], {
                      placeholder: "Clique aqui...",
                      hasError: $setup.listError.includes('Unidade'),
                      label: "Unidade:",
                      options: $setup.compudetUnidades,
                      modelValue: $setup.dados.unidade,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.dados.unidade) = $event)),
                      color: `#697B8E`,
                      class: "mb-3"
                    }, null, 8 /* PROPS */, ["hasError", "options", "modelValue"]),
                    _createCommentVNode(" <AtomSelect placeholder=\"Clique aqui...\" v-if=\"props.stepTri\" :hasError=\"listError.includes('Jitter atual')\"\r\n        label=\"Operador Lógico:\" :color=\"`#697B8E`\" :options=\"jitter\" v-model=\"dados.operador\" class=\"mb-3\">\r\n      </AtomSelect> "),
                    _createCommentVNode(" <AtomInput v-if=\"props.stepTri && trigger?.toLowerCase() == 'jitter'\" v-model=\"dados.jitter\"\r\n        :hasError=\"listError.includes('jitter atual')\" appendIcon label=\"jitter atual:\" :color=\"`#697B8E`\" class=\"mb-3\"\r\n        bgIcon=\"#FFEFE6\">\r\n        <template #appendIcon>\r\n          <p style=\"color: #ff5c00\">Ajustar</p>\r\n        </template>\r\n</AtomInput> "),
                    _createCommentVNode(" <AtomSelect placeholder=\"Clique aqui...\" v-if=\"props.stepTri && trigger?.toLowerCase() == 'Jitter'\"\r\n        :hasError=\"listError.includes('Jitter atual')\" label=\"Jitter atual:\" :color=\"`#697B8E`\" :options=\"jitter\"\r\n        v-model=\"dados.jitter\" class=\"mb-3\">\r\n      </AtomSelect> ")
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_v_col, {
              md: "6",
              cols: "12"
            }, {
              default: _withCtx(() => [
                (!$setup.props.stepTri)
                  ? (_openBlock(), _createBlock($setup["AtomSelect"], {
                      key: 0,
                      placeholder: "Clique aqui...",
                      hasError: $setup.listError.includes('link'),
                      label: "Link:",
                      options: $setup.linksCmputed,
                      color: `#697B8E`,
                      modelValue: $setup.dados.links,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.dados.links) = $event)),
                      class: "mb-3",
                      disabled: !$setup.dados.unidade
                    }, null, 8 /* PROPS */, ["hasError", "options", "modelValue", "disabled"]))
                  : _createCommentVNode("v-if", true),
                ($setup.props.stepTri && $setup.trigger?.toLowerCase() == 'Jitter')
                  ? (_openBlock(), _createBlock($setup["AtomSelect"], {
                      key: 1,
                      placeholder: "Clique aqui...",
                      hasError: $setup.listError.includes('Jitter atual'),
                      label: "Jitter atual:",
                      color: `#697B8E`,
                      options: $setup.jitter,
                      modelValue: $setup.dados.jitter,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.dados.jitter) = $event)),
                      class: "mb-3"
                    }, null, 8 /* PROPS */, ["hasError", "options", "modelValue"]))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_col, {
              md: "6",
              cols: "12"
            }, {
              default: _withCtx(() => [
                (!$setup.props.stepTri)
                  ? (_openBlock(), _createBlock(_component_v_switch, {
                      key: 0,
                      modelValue: $setup.dados.status,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.dados.status) = $event)),
                      color: "success",
                      label: $setup.dados.status ? 'Ativo' : 'Inativo',
                      value: true,
                      "hide-details": ""
                    }, null, 8 /* PROPS */, ["modelValue", "label"]))
                  : _createCommentVNode("v-if", true),
                ($setup.props.stepTri && $setup.trigger?.toLowerCase() == 'Jitter & Latencia'?.toLowerCase())
                  ? (_openBlock(), _createBlock($setup["AtomInput"], {
                      key: 1,
                      modelValue: $setup.dados.latencia,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.dados.latencia) = $event)),
                      hasError: $setup.listError.includes('latencia atual'),
                      label: "Latência atual:",
                      appendIcon: "",
                      color: `#697B8E`,
                      class: "mb-3",
                      bgIcon: "#FFEFE6"
                    }, {
                      appendIcon: _withCtx(() => _cache[33] || (_cache[33] = [
                        _createElementVNode("p", { style: {"color":"#ff5c00"} }, "Ajustar", -1 /* HOISTED */)
                      ])),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue", "hasError"]))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" notification "),
    (
      $setup.trigger?.toLowerCase() == 'Indisponibilidade / Conectividade do Link'?.toLowerCase() ||
      $setup.trigger?.toLowerCase() == 'Indisponibilidade'?.toLowerCase() ||
      $setup.trigger?.toLowerCase() == 'Conectividade do Link'?.toLowerCase()
    )
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          ($setup.notification1)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 0,
                class: "ms-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => _cache[34] || (_cache[34] = [
                      _createElementVNode("h3", null, "1 Notificacao:", -1 /* HOISTED */)
                    ])),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_col, {
                    md: "6",
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.dados.timeFirstNotification1) + " ", 1 /* TEXT */),
                      _createVNode($setup["AtomSelect"], {
                        "align-self": "start",
                        md: "6",
                        cols: "12",
                        hasError: $setup.listError.includes('tempo da 1 Notificação'),
                        label: "tempo da 1 Notificação:",
                        options: $setup.optionsSelectTime,
                        modelValue: $setup.dados.timeFirstNotification1,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.dados.timeFirstNotification1) = $event)),
                        color: `#697B8E`,
                        class: "mb-3"
                      }, null, 8 /* PROPS */, ["hasError", "options", "modelValue"])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_col, {
                    md: "6",
                    cols: "12"
                  }),
                  _createVNode(_component_v_col, {
                    md: "6",
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode($setup["AtomSelect"], {
                        modelValue: $setup.dados.currentQualityAvailability1,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.dados.currentQualityAvailability1) = $event)),
                        label: "Estado atual (Qualidade x Disponibilidade):",
                        hasError: $setup.listError.includes('unidade'),
                        options: $setup.optionsCurrentState,
                        color: `#697B8E`,
                        class: "mb-3"
                      }, null, 8 /* PROPS */, ["modelValue", "hasError", "options"])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_col, {
                    md: "6",
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock($setup["AtomSelect"], {
                        modelValue: $setup.dados.futureQualityAvailability1,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.dados.futureQualityAvailability1) = $event)),
                        key: String($setup.dados?.futureQualityAvailability1?.length),
                        label: "Estado futuro (Qualidade x Disponibilidade):",
                        multiple: "",
                        hasError: $setup.listError.includes('link'),
                        options: $setup.computedOptionsCurrentState,
                        color: `#697B8E`,
                        class: "mb-3"
                      }, null, 8 /* PROPS */, ["modelValue", "hasError", "options"]))
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_col, {
                    md: "6",
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode($setup["AtomInput"], {
                        hasError: $setup.listError.includes('jitter atual'),
                        label: "Somatória total de saltos:",
                        color: `#697B8E`,
                        type: "number",
                        class: "mb-3",
                        modelValue: $setup.dados.sumJumps1,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.dados.sumJumps1) = $event))
                      }, null, 8 /* PROPS */, ["hasError", "modelValue"])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_col, {
                    md: "6",
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode($setup["AtomInput"], {
                        hasError: $setup.listError.includes('latencia atual'),
                        label: "Resultado final da perda de pacote (Salto final):",
                        type: "number",
                        color: `#697B8E`,
                        class: "mb-3"
                      }, null, 8 /* PROPS */, ["hasError"])
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true),
          ($setup.notification2)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 1,
                class: "ms-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => _cache[35] || (_cache[35] = [
                      _createElementVNode("h3", null, "2 Notificacao:", -1 /* HOISTED */)
                    ])),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_col, {
                    md: "6",
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode($setup["AtomSelect"], {
                        "align-self": "start",
                        md: "6",
                        cols: "12",
                        hasError: $setup.listError.includes('tempo da 1 Notificação'),
                        label: "tempo da 1 Notificação:",
                        options: $setup.optionsSelectTime,
                        modelValue: $setup.dados.timeFirstNotification2,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.dados.timeFirstNotification2) = $event)),
                        color: `#697B8E`,
                        class: "mb-3"
                      }, null, 8 /* PROPS */, ["hasError", "options", "modelValue"])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_col, {
                    md: "6",
                    cols: "12"
                  }),
                  _createVNode(_component_v_col, {
                    md: "6",
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode($setup["AtomSelect"], {
                        modelValue: $setup.dados.currentQualityAvailability2,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (($setup.dados.currentQualityAvailability2) = $event)),
                        label: "Estado atual (Qualidade x Disponibilidade):",
                        hasError: $setup.listError.includes('unidade'),
                        options: $setup.optionsCurrentState,
                        color: `#697B8E`,
                        class: "mb-3"
                      }, null, 8 /* PROPS */, ["modelValue", "hasError", "options"])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_col, {
                    md: "6",
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock($setup["AtomSelect"], {
                        modelValue: $setup.dados.futureQualityAvailability2,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($setup.dados.futureQualityAvailability2) = $event)),
                        key: String($setup.dados?.futureQualityAvailability2?.length),
                        label: "Estado futuro (Qualidade x Disponibilidade):",
                        multiple: "",
                        hasError: $setup.listError.includes('link'),
                        options: $setup.computedOptionsCurrentState2,
                        color: `#697B8E`,
                        class: "mb-3"
                      }, null, 8 /* PROPS */, ["modelValue", "hasError", "options"]))
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_col, {
                    md: "6",
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode($setup["AtomInput"], {
                        hasError: $setup.listError.includes('jitter atual'),
                        label: "Somatória total de saltos:",
                        color: `#697B8E`,
                        type: "number",
                        class: "mb-3",
                        modelValue: $setup.dados.sumJumps2,
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (($setup.dados.sumJumps2) = $event))
                      }, null, 8 /* PROPS */, ["hasError", "modelValue"])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_col, {
                    md: "6",
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode($setup["AtomInput"], {
                        hasError: $setup.listError.includes('latencia atual'),
                        label: "Resultado final da perda de pacote (Salto final):",
                        type: "number",
                        color: `#697B8E`,
                        class: "mb-3"
                      }, null, 8 /* PROPS */, ["hasError"])
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true),
          ($setup.notification3)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 2,
                class: "ms-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => _cache[36] || (_cache[36] = [
                      _createElementVNode("h3", null, "3 Notificacao:", -1 /* HOISTED */)
                    ])),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_col, {
                    md: "6",
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode($setup["AtomSelect"], {
                        "align-self": "start",
                        md: "6",
                        cols: "12",
                        hasError: $setup.listError.includes('tempo da 1 Notificação'),
                        label: "tempo da 1 Notificação:",
                        options: $setup.optionsSelectTime,
                        modelValue: $setup.dados.timeFirstNotification3,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (($setup.dados.timeFirstNotification3) = $event)),
                        color: `#697B8E`,
                        class: "mb-3"
                      }, null, 8 /* PROPS */, ["hasError", "options", "modelValue"])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_col, {
                    md: "6",
                    cols: "12"
                  }),
                  _createVNode(_component_v_col, {
                    md: "6",
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode($setup["AtomSelect"], {
                        modelValue: $setup.dados.currentQualityAvailability3,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (($setup.dados.currentQualityAvailability3) = $event)),
                        label: "Estado atual (Qualidade x Disponibilidade):",
                        hasError: $setup.listError.includes('unidade'),
                        options: $setup.optionsCurrentState,
                        color: `#697B8E`,
                        class: "mb-3"
                      }, null, 8 /* PROPS */, ["modelValue", "hasError", "options"])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_col, {
                    md: "6",
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock($setup["AtomSelect"], {
                        modelValue: $setup.dados.futureQualityAvailability3,
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (($setup.dados.futureQualityAvailability3) = $event)),
                        key: String($setup.dados?.futureQualityAvailability3?.length),
                        label: "Estado futuro (Qualidade x Disponibilidade):",
                        multiple: "",
                        hasError: $setup.listError.includes('link'),
                        options: $setup.computedOptionsCurrentState3,
                        color: `#697B8E`,
                        class: "mb-3"
                      }, null, 8 /* PROPS */, ["modelValue", "hasError", "options"]))
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_col, {
                    md: "6",
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode($setup["AtomInput"], {
                        hasError: $setup.listError.includes('jitter atual'),
                        label: "Somatória total de saltos:",
                        color: `#697B8E`,
                        type: "number",
                        class: "mb-3",
                        modelValue: $setup.dados.sumJumps3,
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (($setup.dados.sumJumps3) = $event))
                      }, null, 8 /* PROPS */, ["hasError", "modelValue"])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_col, {
                    md: "6",
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode($setup["AtomInput"], {
                        hasError: $setup.listError.includes('latencia atual'),
                        label: "Critério Qualidade & Disponibilidade < 50:",
                        type: "number",
                        color: `#697B8E`,
                        class: "mb-3"
                      }, null, 8 /* PROPS */, ["hasError"])
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    (!$setup.flow)
      ? (_openBlock(), _createBlock(_component_v_divider, {
          key: 2,
          class: "my-5"
        }))
      : _createCommentVNode("v-if", true),
    (!$setup.flow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[37] || (_cache[37] = _createElementVNode("div", { class: "text-align-center" }, null, -1 /* HOISTED */)),
          _createVNode($setup["AtomAccordion"], {
            titleOrange: true,
            cardClass: "pa-5",
            noChevron: "",
            initialShow: true,
            title: "Condicionamento do gatilho e notificação "
          }, {
            icon: _withCtx(() => [
              _createVNode($setup["ArrowCircleIcon"])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                ($setup.trigger)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_4, _toDisplayString(`Ajustes e configurações para mitigar e notificar os usuários sobre os problemas de ${
              $setup.trigger?.toLowerCase() === 'jitter & latencia'
                ? 'jitter e latência'
                : $setup.trigger?.toLowerCase() === 'jitter'
                  ? 'jitter'
                  : $setup.trigger?.toLowerCase() === 'latencia'
                    ? 'latência'
                    : ''
            } elevados
          em links de internet.`), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" <li\r\n          class=\"text-muted my-5\"\r\n          v-if=\"\r\n            trigger?.toLowerCase() == 'Indisponibilidade / Conectividade do Link'?.toLowerCase() ||\r\n            trigger?.toLowerCase() == 'Indisponibilidade'?.toLowerCase() ||\r\n            trigger?.toLowerCase() == 'Conectividade do Link'?.toLowerCase()\r\n          \"\r\n        >\r\n          O gatilho será acionado quando houver falta de conectividade detectada através de perda de pacotes ou\r\n          instabilidade do link, que pode evoluir do estado saudável para degradado e problemático. Isso será verificado\r\n          por meio de testes de PING (ICMP) e roteamento através de saltos para identificar o ponto de interrupção na\r\n          comunicação do link da unidade.\r\n        </li> ")
              ])
            ]),
            _: 1 /* STABLE */
          })
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" <v-row\r\n    v-if=\"\r\n      trigger?.toLowerCase() == 'Indisponibilidade / Conectividade do Link'?.toLowerCase() ||\r\n      trigger?.toLowerCase() == 'Indisponibilidade'?.toLowerCase() ||\r\n      trigger?.toLowerCase() == 'Conectividade do Link'?.toLowerCase()\r\n    \"\r\n  >\r\n    <v-col class=\"text-center\">\r\n      <AtomButton\r\n        v-if=\"notification1\"\r\n        @click=\"notification1 = false\"\r\n        center=\"text-center\"\r\n        text=\"Voltar\"\r\n        background=\"white \"\r\n        outlined\r\n        class=\"w-100\"\r\n      />\r\n      <AtomButton\r\n        v-if=\"notification2\"\r\n        @click=\"(notification2 = false), (notification1 = true)\"\r\n        center=\"text-center\"\r\n        text=\"Voltar\"\r\n        background=\"white \"\r\n        outlined\r\n        class=\"w-100\"\r\n      />\r\n      <AtomButton\r\n        v-if=\"notification3\"\r\n        @click=\"(notification3 = false), (notification2 = true)\"\r\n        center=\"text-center\"\r\n        text=\"Voltar\"\r\n        background=\"white \"\r\n        outlined\r\n        class=\"w-100\"\r\n      />\r\n    </v-col>\r\n    <v-col class=\"text-center\">\r\n      <AtomButton\r\n        v-if=\"!notification1 && !notification2 && !notification3\"\r\n        @click=\"notification1 = true\"\r\n        :IconText=\"true\"\r\n        :disabled=\"!(trigger && dados.tituloNotificacao && dados.company && dados.unidade && dados.links)\"\r\n        center=\"text-center\"\r\n        text=\"Avançar\"\r\n        background=\"primary \"\r\n        class=\"w-100\"\r\n      >\r\n        <template #IconTextEnd>\r\n          <ArrowCircleRightWhiteIcon />\r\n        </template>\r\n      </AtomButton>\r\n      <AtomButton\r\n        v-if=\"notification1\"\r\n        @click=\"(notification2 = true), (notification1 = false)\"\r\n        :IconText=\"true\"\r\n        :disabled=\"!trigger\"\r\n        center=\"text-center\"\r\n        text=\"Avançar\"\r\n        background=\"primary \"\r\n        class=\"w-100\"\r\n      >\r\n        <template #IconTextEnd>\r\n          <ArrowCircleRightWhiteIcon />\r\n        </template>\r\n      </AtomButton>\r\n      <AtomButton\r\n        v-if=\"notification2\"\r\n        @click=\"(notification3 = true), (notification2 = false)\"\r\n        :IconText=\"true\"\r\n        :disabled=\"!trigger\"\r\n        center=\"text-center\"\r\n        text=\"Avançar\"\r\n        background=\"primary \"\r\n        class=\"w-100\"\r\n      >\r\n        <template #IconTextEnd>\r\n          <ArrowCircleRightWhiteIcon />\r\n        </template>\r\n      </AtomButton>\r\n      <AtomButton\r\n        v-if=\"notification3\"\r\n        @click=\"handleAddOrUpdate(), (notification3 = true)\"\r\n        :IconText=\"true\"\r\n        :disabled=\"!trigger\"\r\n        center=\"text-center\"\r\n        :text=\"props.id.id ? 'Atualizar' : 'Criar'\"\r\n        background=\"primary \"\r\n        class=\"w-100\"\r\n      >\r\n        <template #IconTextEnd>\r\n          <ArrowCircleRightWhiteIcon />\r\n        </template>\r\n      </AtomButton>\r\n    </v-col>\r\n  </v-row>\r\n  <v-row v-else>\r\n    <v-col class=\"text-center\">\r\n      <AtomButton\r\n        @click=\"handleBackJittler\"\r\n        center=\"text-center\"\r\n        text=\"Voltar\"\r\n        background=\"white \"\r\n        outlined\r\n        class=\"w-100\"\r\n      />\r\n    </v-col>\r\n    <v-col class=\"text-center\">\r\n      <AtomButton\r\n        v-if=\"jitterLatencia == false\"\r\n        @click=\"handleJittlerNext\"\r\n        :IconText=\"true\"\r\n        :disabled=\"!(trigger && dados.tituloNotificacao && dados.company && dados.unidade && dados.links)\"\r\n        center=\"text-center\"\r\n        text=\"Avançar\"\r\n        background=\"primary\"\r\n        class=\"w-100\"\r\n      >\r\n        <template #IconTextEnd>\r\n          <ArrowCircleRightWhiteIcon />\r\n        </template>\r\n      </AtomButton> \r\n      \r\n && dados.timeSecondNotification && dados.operador2 && dados.ValorRegra2 && dados.timeThirdNotification && dados.operador3 && dados.ValorRegra3\r\n     \r\n      <AtomButton\r\n      \r\n        @click=\"handleAddOrUpdate\"\r\n        :IconText=\"true\"\r\n        :disabled=\"dados.timeFirstNotification && dados.operador1 && dados.ValorRegra1 ? false : true\"\r\n        center=\"text-center\"\r\n        :text=\"props.id.id ? 'Atualizar' : 'Criar'\"\r\n        background=\"primary \"\r\n        class=\"w-100\"\r\n      >\r\n        <template #IconTextEnd>\r\n          <ArrowCircleRightWhiteIcon />\r\n        </template>\r\n      </AtomButton>\r\n    </v-col>\r\n  </v-row> ")
  ], 64 /* STABLE_FRAGMENT */))
}